import { render, staticRenderFns } from "./SingleChoiceElement.vue?vue&type=template&id=180e0cb2&scoped=true&"
import script from "./SingleChoiceElement.vue?vue&type=script&lang=ts&"
export * from "./SingleChoiceElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e0cb2",
  null
  
)

export default component.exports